import { render, staticRenderFns } from "./FindingInfoByOrgan.vue?vue&type=template&id=c6922a68&"
import script from "./FindingInfoByOrgan.vue?vue&type=script&lang=js&"
export * from "./FindingInfoByOrgan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports